import { useState, useEffect, useRef, useCallback } from 'react';
import config from '@/config';
export const useRecaptcha = (containerId, action, active) => {
    const [token, setToken] = useState('');
    const widgetIdRef = useRef(null);
    const reset = useCallback(() => {
        var _a;
        setToken('');
        if (widgetIdRef.current !== null && ((_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise)) {
            window.grecaptcha.enterprise.reset(widgetIdRef.current);
        }
    }, []);
    useEffect(() => {
        if (!active) {
            setToken('');
            widgetIdRef.current = null;
            return;
        }
        const timer = setTimeout(() => {
            var _a;
            if (!((_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise))
                return;
            const container = document.getElementById(containerId);
            if (!container)
                return;
            if (widgetIdRef.current !== null) {
                window.grecaptcha.enterprise.reset(widgetIdRef.current);
            }
            else {
                widgetIdRef.current = window.grecaptcha.enterprise.render(containerId, {
                    sitekey: config.recaptchaKey,
                    action,
                    callback: setToken,
                });
            }
        }, 200);
        return () => clearTimeout(timer);
    }, [active, containerId, action]);
    return { token, reset };
};
